// extracted by mini-css-extract-plugin
export default {"block_user_posts":"Posts_block_user_posts__YzzvP"};